import "./style.css";
import {
  CopyrightOutlined,
  LinkedinFilled,
  MailFilled,
} from "@ant-design/icons";
import { queryMailAddress } from "Constants/constants";
import { ROUTES } from "Features/Routes/routeConstants";
import { useNavigate } from "react-router-dom";
import SendMessage from "../SendMessage/SendMessage";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer-container">
      {/* Left Section */}
      <SendMessage />
      <div className="footer-inner-container">
        <div className="footer-left">
          <div className="footer-logo">
            <img
              src={
                "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
              }
              alt="Logo"
            />
          </div>
          <p className="footer-text text-base text-gray-700 font-medium">
            A Fully Integrated One-Stop Platform For College, Financial,
            Immigration And Career Solutions
          </p>
          <h4>Connect With Us</h4>
          <div className="footer-social-icons">
            <a
              href="https://www.linkedin.com/company/onegradai/about/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedinFilled />
            </a>
            <a
              href={`mailto:${queryMailAddress}`}
              target="_blank"
              rel="noreferrer"
            >
              <MailFilled />
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-grid">
          <ul>
            <li
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </li>
            <li
              onClick={() => {
                navigate(ROUTES.OUR_TEAM);
              }}
            >
              Our Team
            </li>
            <li
              onClick={() => {
                navigate(ROUTES.BLOG);
              }}
            >
              Blog
            </li>
            <li
              onClick={() => {
                navigate(ROUTES.PRICING);
              }}
            >
              Pricing
            </li>
            <a href={`mailto:${queryMailAddress}`}>
              <li>Contact Us</li>
            </a>
          </ul>
        </div>
      </div>
      <div className="footer-copyright">
        <p>
          Copyright {new Date().getFullYear()}&nbsp;
          <CopyrightOutlined /> Onegrad LLC and Best I20 Private Ltd.
          <button
            className="footer-policy-link"
            onClick={() => navigate(ROUTES.PRIVACY_POLICY)}
          >
            Privacy Policy
          </button>
          <button
            className="footer-policy-link"
            onClick={() => navigate(ROUTES.TERMS)}
          >
            Terms & Conditions
          </button>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
